module.exports = __webpack_public_path__ + "static/media/cimb_islamic.afedb21c.svg";